/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryResponse,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsPathParams,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryParams,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels401,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels500,
} from "../../types/individualPaymentLookupsController/GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels.ts";

function getGetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsUrl(
  courseFinancialId: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsPathParams["courseFinancialId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/course-financials/${courseFinancialId}/available-number-parcels` as const,
  };
  return res;
}

/**
 * @description Retorna 1..N do método (mínimo 1) mais a opção "Outros"; 'currentNumberParcels' maior que N prevalece. Migrado do legado IndividualPayment/GetAvailableNumberParcelsByCourse. **(Requer Authorization para autenticação)**
 * @summary Opções de número de parcelas do método de pagamento (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/course-financials/:courseFinancialId/available-number-parcels}
 */
export async function getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels(
  courseFinancialId: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsPathParams["courseFinancialId"],
  params?: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels401
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsUrl(
      courseFinancialId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
